import { render, staticRenderFns } from "./DictionaryIndex.vue?vue&type=template&id=71a80b60&scoped=true&"
import script from "./DictionaryIndex.vue?vue&type=script&lang=js&"
export * from "./DictionaryIndex.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryIndex.vue?vue&type=style&index=0&id=71a80b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a80b60",
  null
  
)

export default component.exports